import ApiService from "@/core/services/api.service";
import {PURGE_AUTH} from "./auth.module";
import JwtService from "@/core/services/jwt.service";
import {SET_PAGINATE} from "./paginate.module";


// action types
export const ADD_CITY = "addCity";
export const GET_CITIES = "getCities";
export const UPDATE_CITY = "updateCity";
export const DELETE_CITY = "deleteCity";

// mutation types
export const SET_CITY_ERROR = "setErrorsCity";
export const SET_CITIES = "setCities";
export const SET_CITY = "setCity";
export const SET_CITY_EDIT = "setCityEdit";
export const SET_CITY_LOAD = "setCityLoad";


const state = {
    errors: {},
    load: false,
    city: {},
    cities:[],

};


const getters = {
    gettersCities(state) {
        return state.cities;
    },
    gettersCity(state) {
        return state.city;
    },
    
    errorsCities(){
        return state.errors;
    },
    
    getCityLoad(){
        return state.load;
    },
};

const actions = {

    [ADD_CITY](context, data){
        return new Promise((resolve, reject) => {
            context.commit(SET_CITY_ERROR, {});
            ApiService.post("/city/store", data)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                    if (response.status === 422){
                        context.commit(SET_CITY_ERROR, response.data.errors);
                    }
                });
        });
    },

    [GET_CITIES](context, data) {
        
        return new Promise((resolve, reject) => {
            context.commit(SET_CITY_LOAD, true);
            ApiService.post("/cities", data)
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_CITIES, data);
                    context.commit(SET_PAGINATE, data);
                    context.commit(SET_CITY_LOAD, false);
                })
                .catch(({ response }) => {
                    reject(response);
                    context.commit(SET_CITY_ERROR, response.data.errors);
                    context.commit(SET_CITY_LOAD, false);
                });
        });
        
    },

    [UPDATE_CITY](context, data) {
        if (JwtService.getToken()) {
            context.commit(SET_CITY_ERROR, {});
            return new Promise((resolve, reject) => {
                ApiService.update("/city/update", data.id, data)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_CITY_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                        if (response.status === 422){
                            context.commit(SET_CITY_ERROR, response.data.errors);
                        }
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

    [DELETE_CITY](context, id) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.delete("/city/destroy", id)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_CITY_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    }


};

const mutations = {
    [SET_CITY_ERROR](state, error) {
        state.errors = error;
    },

    [SET_CITIES](state, data) {
        state.cities = data.data;
    },


    [SET_CITY](state, data) {
        state.city = data.city;
    },


    [SET_CITY_EDIT](state, data) {
        state.city = data.city;
    },


    [SET_CITY_LOAD](state, load) {
        state.load = load;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
